
import React, { useState, useEffect }  from "react";
import { connect } from "react-redux";
import moment from 'moment';

import MenuItem from '@material-ui/core/MenuItem';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  updateVeterinaryClinic,
} from '../api/VeterinaryClinic.api';
import { getAllstate } from '../api/state.api';



const LoftyVeterinaryClinicUpdateModal = ({open, handleClose, successAction, token, doc}) => {
  const [dataLoftystate, setDataLoftystate] = useState([]);

  
  useEffect(() => {
    const handleDataLoftyApps = async () => {
      try {
				const resLoftystate = await getAllstate({ token });
				setDataLoftystate(resLoftystate.data);


      } catch (error) {
        // error
      }
    }
    handleDataLoftyApps();
  }, []);
  return (
    <Dialog fullWidth open={open} onClose={handleClose}>
      <DialogTitle>
        Actualizar VeterinaryClinic
      </DialogTitle>
      <DialogContent>
        <form
          onSubmit={async e => {
            e.preventDefault();
            try {
              await updateVeterinaryClinic({
                token: token,
                _id: doc._id,
                name: e.target.name.value,
							phone: e.target.phone.value,
							idState: e.target.idState.value,

              });
              if (successAction) {
                successAction();
              }
              alert('Se agrego exitosamente el dato');
            } catch (error) {
              if (error.info) {
                alert(error.info);
              } else {
                alert('Lo sentimos no se logro agregar el dato');
              }
            }
          }}
        >
  				<div className="my-3">
					<TextField type="text" name="name" label="Nombre" variant="outlined" defaultValue={doc?.name} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="phone" label="Telefono" variant="outlined" defaultValue={doc?.phone} fullWidth />
				</div>
				<div className="my-3">
					<TextField name="idState" label="idState" defaultValue={doc?.idState} variant="outlined" fullWidth select>
						{
							dataLoftystate.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.name}</MenuItem>
							))
						}
					</TextField>
				</div>

          <div className="my-3 text-center">
            <Button type="submit" variant="outlined" color="primary">
              Actualizar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = state => state.auth;

export default connect(mapStateToProps)(LoftyVeterinaryClinicUpdateModal);
